import React, { forwardRef } from 'react';
import { playSoundEffect } from '../hooks/useSoundEffects';
import { MENU_BACK_BUTTON_PATH } from '../config/welcomeAssets';
import { resolvePublicAssetBackgroundUrl } from '../utils/resolvePublicAssetUrl';
import './MenuPaintedButton.css';

const MenuPaintedButton = forwardRef(function MenuPaintedButton({
  onClick,
  className = '',
  style,
  disabled = false,
  active = false,
  children,
  playClickSound = true,
  leadingArrow = false,
  trailingArrow = false,
  imagePath = MENU_BACK_BUTTON_PATH,
  surfaceFilter,
  type = 'button',
  ...rest
}, ref) {
  const buttonImage = resolvePublicAssetBackgroundUrl(imagePath);

  const handleClick = (event) => {
    if (disabled) {
      return;
    }
    if (playClickSound) {
      playSoundEffect('/sounds/click.mp3');
    }
    if (!onClick) {
      throw new Error('MenuPaintedButton requires `onClick`');
    }
    onClick(event);
  };

  return (
    <button
      ref={ref}
      type={type}
      className={`menu-painted-button${active ? ' active' : ''} ${className}`.trim()}
      onClick={handleClick}
      disabled={disabled}
      style={{
        '--menu-painted-button-image': buttonImage,
        ...(surfaceFilter ? { '--menu-painted-button-filter': surfaceFilter } : {}),
        ...style,
      }}
      {...rest}
    >
      <span className="menu-painted-button__content">
        {leadingArrow ? (
          <span className="menu-painted-button__arrow" aria-hidden="true">←</span>
        ) : null}
        <span className="menu-painted-button__text">{children}</span>
        {trailingArrow ? (
          <span className="menu-painted-button__arrow" aria-hidden="true">→</span>
        ) : null}
      </span>
    </button>
  );
});

export default MenuPaintedButton;
